<template>
    <section class="c-products-promotion" :class="[background, spaces]">
        <div class="c-container">
            <div class="c-products-promotion__headline psb-30 psb-md-60">
                <div class="c-row">
                    <div class="c-grid align-middle">
                        <div class="cell sm-12 md-6">
                            <h2 class="headline psb-20 psb-md-0" v-html="nl2br(data.title)"></h2>
                        </div>
                        <div class="cell md-cell-right sm-12 md-6">
                            <div v-if="!!data.links.length" class="c-links">
                                <UiArrowLink
                                    v-for="(link, index) in data.links"
                                    :key="index"
                                    :link="link"
                                    :style="'dark'"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="c-products-promotion__grid">
                <component
                    v-for="item in data.promotions"
                    :is="equalTemplates[item.promotionType]"
                    :key="item.id"
                    :data="item"
                    :is-animated="true"
                />
            </div>
        </div>
    </section>
</template>

<script setup>
    const props = defineProps({
        data: {
            type: Object,
            default: {}
        },
        background: {
            type: String,
            default: "bg-white"
        },
        spaces: {
            type: String,
            default: "pst-100 psb-100 pst-md-150 psb-md-200"
        }
    });

    const standart = resolveComponent("CardsProductPromotion");
    const subscribe = resolveComponent("CardsSubscribe");

    const equalTemplates = computed(() => ({
        standart: standart,
        subscribe: subscribe
    }));
</script>
